<template>
	<div class="page_warp">
		<div class="top_content">
			<div class="top_input2">
				<el-select v-model="checkType" placeholder="请选择">
					<el-option label="车牌号" value="1"> </el-option>
				</el-select>
			</div>
			<div class="top_input3">
				<el-select v-model="checkTypeValue" filterable placeholder="请选择" clearable>
					<el-option v-for="(item, index) in checkTypeList" :key="index" :label="item.value"
						:value="item.index">
						<!-- <span style="float: left">{{ item.value }}</span>
						<span style="
						          float: right;
						          color: var(--el-text-color-secondary);
						          font-size: 13px;
						        ">
							{{ item.index }}
						</span> -->
					</el-option>
				</el-select>
				<!-- <el-input type="text" placeholder="请输入" v-model="searchWord"></el-input> -->
			</div>
			<div class="top_input5">
				<el-select v-model="checkexpireStatus" placeholder="请选择轮胎更换状态">
					<el-option label="正常" value="0"> </el-option>
					<el-option label="临期" value="1"> </el-option>
					<el-option label="过期" value="2"> </el-option>
				</el-select>
			</div>
			<div class="search_btn" @click="getData">查询</div>
			<div class="add_btn" @click="add">添加轮胎更换提醒</div>
		</div>
		<div class="bottom_content">
			<div class="table_container" v-bind:id="tableId">
				<el-table v-bind:data="tableData" stripe border style="width: 100%" v-bind:max-height="tableHeight"
					:default-sort="{ prop: 'whType', order: 'descending' }" v-bind:header-cell-style="{
            textAlign: 'center',
            color: '#333333',
            background: '#F5F5F5',
          }" v-bind:cell-style="{ textAlign: 'center' }" empty-text="暂无数据">
					<el-table-column type="index" label="序号" width="80"></el-table-column>
					<el-table-column prop="vehNo" label="车牌号码" width="150"></el-table-column>
					<el-table-column prop="vempStatus" label="当前状态" width="120">
						<template #default="scope">
							<span v-if="scope.row.expireDateStatus === '0'" style="color: #00aa00;">正常</span>
							<span v-else-if="scope.row.expireDateStatus === '1'" style="color: #0000ff;">快到期</span>
							<span v-else style="color: #ff0000;">过期</span>
						</template>
					</el-table-column>
					<el-table-column prop="sumCount" label="总更换次数" width="120"></el-table-column>
					<el-table-column prop="sumQuantity" label="总更换条数" width="120"></el-table-column>
					<el-table-column prop="whName" label="轮胎规格" width="150"></el-table-column>
					<el-table-column prop="vempLastDate" label="上次更换日期" width="170"></el-table-column>
					<el-table-column prop="vempLastMiles" label="上次更换里程" width="120"></el-table-column>
					<el-table-column prop="vempMilesInterval" label="更换里程周期" width="120"></el-table-column>
					<el-table-column prop="remainMiles" label="距下次更换里程" width="130"></el-table-column>
					<el-table-column prop="vempMilesAdvance" label="提前提醒里程" width="120"></el-table-column>
					<el-table-column prop="vempDateInterval" label="更换时间周期" width="120"></el-table-column>
					<el-table-column prop="remainDay" label="距下次更换时间" width="130"></el-table-column>
					<el-table-column prop="vempDateAdvance" label="提前提醒时间" width="120"></el-table-column>
					<el-table-column prop="vempModtime" label="更新时间" width="170"></el-table-column>
					<el-table-column label="操作" fixed="right" width="210">
						<template #default="scope">
							<span class="default_color pointer m-right10"
								v-on:click="edit(scope.row.vempId)">编辑</span>
							<span class="col-FF1A1A pointer m-right10"
								v-on:click="del(scope.row.vempVehId)">删除</span>
							<span class="default_color pointer m-right10"
								v-on:click="detail(scope.row.vempId,scope.row.vempVehId)">记录</span>
							<span class="default_color pointer m-right10"
								v-on:click="addRecord(scope.row.vempVehId,scope.row.vehNo)">更换轮胎</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="flex flex-y-center flex-x-center">
				<el-config-provider :locale="locale">
					<el-pagination background v-model:currentPage="page" v-model:page-size="pageSize"
						:page-sizes="[5, 10, 15, 20]" layout="sizes, prev, pager, next, total, jumper"
						:total="totalCount" @size-change="getData" @current-change="getData" />
				</el-config-provider>
			</div>
		</div>

		<Add ref="addRef" v-if="isAdd" @getData="getData" />
		<Edit ref="editRef" v-if="isEdit" @getData="getData" />
		<Detail ref="detailRef" v-if="isDetail" @getData="getData" />
		<AddRecord ref="addRecordRef" v-if="isAddRecord" @getData="getData" />
		<!-- <div class="menuManagemen" v-if="isAdd">
      <Add :sendData="sendData" @closeModal="closeModal" @getData="getData" />
    </div>
    <div class="menuManagemen" v-if="isEdit">
      <Edit :sendData="sendData" @closeModal="closeModal" @getData="getData" />
    </div>
    <div class="menuManagemen" v-if="isDetail">
      <Detail
        :sendData="sendData"
        @closeModal="closeModal"
        @getData="getData"
      />
    </div> -->
	</div>
</template>

<script>
	import {
		computed,
		defineComponent,
		reactive,
		toRefs,
		nextTick,
		onMounted,
		getCurrentInstance,
	} from "vue";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	import Add from "./components/add";
	import Edit from "./components/edit";
	import Detail from "./components/detail";
	import AddRecord from "./components/addRecord";
	import zhCn from "element-plus/es/locale/lang/zh-cn";
	export default defineComponent({
		components: {
			Add,
			Edit,
			Detail,
			AddRecord
		},
		name: "tire",
		setup() {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const data = reactive({
				tableId: "orgManagementTable",
				page: 1,
				pageSize: 10,
				searchWord: "",
				checkexpireStatus: "",
				totalCount: 0,
				tableData: [],
				tableHeight: 0,
				isAdd: false,
				isAddRecord: false,
				isEdit: false,
				isDetail: false,
				sendData: null,
				locale: zhCn,
				cocId: "",
				cocList: [], //客商列表
				checkType: "1",
				checkTypeValue: "",
				checkTypeList: [],

				expireDateStatus: "0", //时间到期状态：0未到期，1临期，2过期
				expireMilesStatus: null, //里程到期状态：0未到期，1临期，2过期
				remainDay: 182, //剩余天数
				remainMiles: null, //剩余公里数
				sumCount: 0, //总保养次数
				sumMoney: 0, //总保养金额
				sumQuantity: 0, //总件数
				vehNo: "渝A7H600", //车牌号
				vehOrg: "1749530636886", //外键，所属机构
				vehOrgName: "重庆迪信达物流有限责任公司",
				vempCreator: 78, //创建人用户ID,外键
				vempCreatorName: "kuangjingnian", //创建人姓名
				vempCretime: "2025-12-25 23:15:33", //创建时间
				vempDateAdvance: 30, //提前提醒时间，单位：天 
				vempDateInterval: 6, //提醒时间周期，单位：月 
				vempExpireDate: "2026-06-25", //本次到期日期
				vempExpireMiles: 30000, //本次到期公里数
				vempId: 1, //自增ID
				vempLastDate: "2025-12-25 23:15:04", //上次更新时间，yyyyMMdd
				vempLastMiles: 10000, //上次更新里程，单位：公里 
				vempMilesAdvance: 1000, //提前提醒里程，单位：公里 
				vempMilesInterval: 20000, //提醒里程周期，单位：公里 
				vempModtime: null, //最近修改时间
				vempModuser: null, //最近修改人用户ID，外键
				vempModuserName: null,
				vempRemark: "常规保养", //备注
				vempStatus: "0", //状态：0正常，1停用
				vempType: "1", //类型：0轮胎1保养2维修
				vempVehId: 48, //车辆信息表ID，外键

				permissionItem: {
					list: false,
					add: false,
					edit: false,
					del: false,
				},
			});
			onMounted(() => {

				console.log(store.state.userInfo);
				nextTick(() => {
					data.tableHeight =
						document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight - 40;
					getData();
					checkTypeChange("1");

				});
				window.onresize = () => {
					nextTick(() => {
						var offsetHeight = document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight;
						if (offsetHeight <= 0) {
							return false;
						}
						data.tableHeight = document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight;
					});
				};
			});
			//获取列表数据
			const getData = async () => {
				let params = {
					searchWord: data.searchWord,
					page: data.page,
					limit: data.pageSize,
					vempType: '0',
					vehNo: data.checkTypeValue,
					vehOrg: '',
					expireDateStatus: data.checkexpireStatus,
				};
				const r = await proxy.$http.get(apiObj.vehMaintenanceProdlist, params);
				console.log(r);
				if (r.code === 0) {
					// r.rows.forEach((el) => {
					// 	el.whStatusBoolen = el.whStatus == 0 ? true : false;
					// });
					data.tableData = r.rows;
					data.totalCount = r.total;
				}
			};

			const checkTypeChange = async (value) => {
				data.checkTypeValue = "";
				if (value == "1") {
					//获取车辆
					let params = {
						searchWord: "",
						page: 1,
						limit: "10000",
					};
					const res = await proxy.$http.get(apiObj.vehicleList, params);
					console.log(res);
					data.checkTypeList = [];
					if (res.code === 0 || res.respCode === '0000') {
						res.rows.forEach((el) => {
							data.checkTypeList.push({
								value: el.vehHeadNo,
								index: el.vehHeadNo,
							});
						});
					}
				}
			};

			//获取所属托运商
			const getCocList = async () => {

				let params = {
					page: 1,
					limit: 10000,
					searchWord: "",
				};
				const res = await proxy.$http.get(apiObj.cusList, params);
				console.log(res);
				if (res.code == 0) {
					data.cocList = res.rows;
				}
			};

			// 添加 根目录
			const add = () => {

				data.isAdd = true;
				nextTick(() => {
					proxy.$refs.addRef.init();
				});
			};

			//添加轮胎使用记录
			const addRecord = (id, vehNo) => {

				data.isAddRecord = true;
				nextTick(() => {
					proxy.$refs.addRecordRef.init(id, vehNo);
				});
			};

			// 菜单编辑
			const edit = (id) => {

				data.isEdit = true;
				nextTick(() => {
					proxy.$refs.editRef.init(id);
				});
			};
			// 菜单详情
			const detail = (id,VehId) => {

				data.isDetail = true;
				nextTick(() => {
					proxy.$refs.detailRef.init(id,VehId);
				});
			};
			//菜单删除
			const del = (id) => {
				proxy
					.$confirm("您确定删除选中的数据吗", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(async () => {
						let params = {
							vempVehId: id,
						};
						const r = await proxy.$http.postFormData(apiObj.vehMaintenanceProdremoveTire,
							params);
						if (r.respCode == 0 || r.respCode == "0000") {
							proxy.$message.success(r.msg || r.respMsg);
							getData();
						} else {
							proxy.$message.error(r.msg || r.respMsg);
						}
					});
			};

			const updateState = (row) => {

				proxy.$confirm(
					`您确定执行${!row.whStatusBoolen ? "启用" : "禁用"}操作，是否继续?`,
					"提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					}
				).then(async () => {
					proxy.$http
						.postFormData(
							"/biz/bdzl/warehouse/updateStatus", {
								whId: row.whId,
								status: row.whStatusBoolen ? 1 : 0
							}, {
								headers: {
									"Content-Type": "application/x-www-form-urlencoded"
								},
							}
						)
						.then((res) => {
							if (res.code == 0 || res.respCode == "0000") {
								proxy.$message.success(res.msg || res.respMsg);
								getData();
							} else {
								proxy.$message.info(res.msg || res.respMsg);
							}
						});
				});
			};

			return {
				...toRefs(data),
				getData,
				add,
				edit,
				detail,
				del,
				updateState,
				addRecord,
			};
		},
	});
</script>

<style scoped>
	.page_warp {
		width: 100%;
		height: 100%;
	}

	.cell-style {
		white-space: nowrap;
		/* 防止内容换行 */
		overflow: hidden;
		/* 超出部分隐藏 */
		text-overflow: ellipsis;
		/* 显示省略符号来代表被修剪的文本 */
	}

	.add_btn {
		width: 140px;
		height: 38px;
		background: #293787;
		border-radius: 4px;
		cursor: pointer;
		text-align: center;
		line-height: 38px;
		font-size: 14px;
		color: #ffffff;
		margin-left: 10px;
	}
</style>